import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ChevronLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import { api, resolveImageUri } from "@/lib/api";

function youtubeEmbed(url) {
  const m = url.match(/(?:youtu\.be\/|v=|\/embed\/|\/shorts\/)([\w-]{11})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}

export default function BlogDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: post, isLoading } = useQuery({ queryKey: ["post", id], queryFn: () => api.getPost(id) });

  return (
    <div className="min-h-screen bg-paper">
      <Header />
      <main className="mx-auto max-w-3xl px-4 sm:px-6 py-8">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-sm text-muted2 hover:text-brand mb-5"><ChevronLeft size={16} /> Back</button>
        {isLoading || !post ? (
          <p className="text-muted2">Loading…</p>
        ) : (
          <article>
            <span className="text-[11px] font-semibold uppercase tracking-wide text-brand">{post.type === "vlog" ? "Vlog" : "Blog"}</span>
            <h1 className="font-display text-4xl sm:text-5xl text-ink leading-tight mt-1" data-testid="post-title">{post.title}</h1>
            <p className="text-xs text-muted2 mt-2">{(post.created_at || "").slice(0, 10)}</p>

            {post.type === "vlog" ? (
              <div className="mt-6 rounded-2xl overflow-hidden bg-black aspect-video">
                {post.youtube_url && youtubeEmbed(post.youtube_url) ? (
                  <iframe src={youtubeEmbed(post.youtube_url)} title={post.title} className="w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-testid="vlog-youtube" />
                ) : post.video_url ? (
                  <video src={resolveImageUri(post.video_url)} controls className="w-full h-full" data-testid="vlog-video" />
                ) : null}
              </div>
            ) : (
              <>
                {post.cover_image && <img src={resolveImageUri(post.cover_image)} alt="" className="w-full rounded-2xl mt-6 object-cover" />}
                <div className="prose prose-sm max-w-none mt-6 text-ink/85 leading-relaxed whitespace-pre-line text-[15px]" data-testid="blog-content">{post.content}</div>
              </>
            )}
          </article>
        )}
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
